import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Card } from "@/components/common";
import { webPushSupported, webPushEnabled, enableWebPush, disableWebPush } from "@/lib/webPush";

const SNOOZE_KEY = "mcf.push.snoozeAt";

// Toggle Notifiche Push nel Profilo. Riusa il sistema Web Push esistente
// (enableWebPush/disableWebPush): nessun secondo sistema di notifiche.
export function PushToggle() {
  const supported = webPushSupported();
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    if (!supported) return;
    setBlocked(Notification.permission === "denied");
    webPushEnabled().then(setOn).catch(() => {});
  }, [supported]);

  const handleToggle = async (next) => {
    if (busy) return;
    setBusy(true);
    try {
      if (next) {
        const res = await enableWebPush(true).catch(() => ({ ok: false, reason: "error" }));
        if (res.ok) {
          setOn(true);
          setBlocked(false);
          localStorage.removeItem(SNOOZE_KEY);
          toast.success("Notifiche Push attivate");
        } else if (res.reason === "denied") {
          setBlocked(true);
          toast("Abilita le notifiche dalle impostazioni del dispositivo");
        } else {
          toast("Non è stato possibile attivare le notifiche in questo momento.");
        }
      } else {
        await disableWebPush();
        setOn(false);
        // Scelta esplicita: il banner Home non deve riproporsi inutilmente.
        localStorage.setItem(SNOOZE_KEY, String(Date.now()));
        toast.success("Notifiche Push disattivate");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="space-y-2" data-testid="push-toggle-card">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/15 text-primary">
          <BellRing className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-extrabold text-foreground">Notifiche Push</p>
          <p className="text-sm text-muted-foreground">Avvisi su viaggi, missioni, messaggi e aggiornamenti.</p>
        </div>
        <Switch
          data-testid="push-toggle-switch"
          checked={on}
          disabled={busy || !supported}
          onCheckedChange={handleToggle}
        />
      </div>
      {!supported ? (
        <p className="text-xs text-muted-foreground">Le notifiche Push non sono supportate su questo browser. Su iPhone aggiungi MyCargoFlow alla schermata Home.</p>
      ) : blocked ? (
        <p data-testid="push-toggle-blocked" className="text-xs text-destructive">Abilita le notifiche dalle impostazioni del dispositivo.</p>
      ) : null}
    </Card>
  );
}
